import React, { useRef } from "react";
import { Button } from "../../../../ui/button";
import { CircleCheckBig, ChevronDown } from "lucide-react";
import { makeStyles, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles({
  notchedOutline: {
    border: "none",
  },
  /*optionSelected: {
    backgroundColor: "#f0f5f0 !important",
    color: "#000",
    width: "100%",
  },
  optionHover: {
    backgroundColor: "#f0f5f0 !important",
  },*/
});

const ClientSelectionCard = ({
  activateClient,
  clients,
  clientItem,
  setClientItem,
  handleClientSelected,
}) => {
  const classes = useStyles();

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6">
      <span className="text-lg text-gray-700 font-medium">
        Client Selection
      </span>

      <div className="flex items-end space-x-4 justify-between container-client-selection">
        <div className="flex flex-col client-selection">
          <label className="text-gray-600 mt-2 mb-0.5 font-medium">
            Select Client
          </label>
          <Autocomplete
            size="small"
            id="combo-box-demo"
            defaultValue={null}
            getOptionLabel={(option) => option.clientName}
            value={clientItem}
            onChange={(event, newValue) => {
              setClientItem(newValue);
              if (newValue) handleClientSelected(newValue, true);
            }}
            popupIcon={<ChevronDown className="w-5 h-5" />}
            renderInput={(params) => (
              <TextField
                className="!rounded-xl border border-input "
                {...params}
                variant="outlined"
                label=""
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    notchedOutline: classes.notchedOutline,
                  },
                }}
              />
            )}
            renderOption={(option, { selected }) => (
              <div className={selected ? classes.optionSelected : ""}>
                {option.clientName}
              </div>
            )}
            sx={{ mt: 2 }}
            options={clients || []}
          />
        </div>

        <Button
          className={`!bg-teal-600 hover:bg-teal-800 text-white !rounded-xl !h-9 gap-2 ml-0`}
          onClick={activateClient}
        >
          <CircleCheckBig className="w-4 h-4" /> Active Client
        </Button>
      </div>
    </div>
  );
};

export default ClientSelectionCard;
